import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import LoginSplash from "components/Common/LoginSplash";

export default class MFAIntro extends PureComponent {
  /**
   * @returns {HTMLObjectElement}
   */
  render() {
    const { clientName, onClick, currentStep } = this.props;

    if (currentStep !== 1) {
      return null;
    }

    return (
      <LoginSplash
        title="Set Up Multi-Factor Authentication"
        button={{
          label: "Set Up Now",
          action: () => onClick()
        }}
        description={`${clientName} Bot now requires all members to enable a second log-in step. This adds an extra layer of protection by linking your account with your phone number. Whenever you sign in with your password, we’ll send you a code via SMS`}
      />
    );
  }
}

MFAIntro.propTypes = {
  onClick: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  clientName: PropTypes.string.isRequired
};
